<template>
    <div>
        <about-us-component></about-us-component>
        <products-component></products-component>
        <news-component></news-component>
        <recruitment-component></recruitment-component>
        <partners-component></partners-component>
    </div>
</template>

<script>
    /**
     * Import components
     */
    import AboutUsComponent from '../blocks/AboutUsComponent';
    import ProductsComponent from '../blocks/ProductsComponent';
    import NewsComponent from '../blocks/NewsComponent';
    import RecruitmentComponent from '../blocks/RecruitmentComponent';
    import PartnersComponent from '../blocks/PartnersComponent';

    export default {
        name: "HomePageComponent",
        components: {
            AboutUsComponent,
            ProductsComponent,
            NewsComponent,
            RecruitmentComponent,
            PartnersComponent
        }
    }
</script>

<style scoped>

</style>
